export const validateEmailUniqueness = (
  currentIndex: number,
  arrayFieldName: string,
  emailFieldName: string = 'email',
  errorMessage?: string
) => {
  return ({ getFieldsValue }: { getFieldsValue: () => any }) => ({
    validator(_: any, value: string) {
      // Skip validation if email is empty
      if (!value?.trim()) {
        return Promise.resolve()
      }

      const formValues = getFieldsValue()
      const items = formValues[arrayFieldName] || []
      const normalizedEmail = value.trim().toLowerCase()

      // Check for duplicates
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        if (i !== currentIndex && item?.[emailFieldName]?.trim().toLowerCase() === normalizedEmail) {
          return Promise.reject(new Error(errorMessage || 'This email is already used by another entry'))
        }
      }

      return Promise.resolve()
    }
  })
}
